export default __webpack_public_path__ + "static/animation-img7-83364e5c9739f975b20062089fbad4e4.webp";